import React, { useState } from 'react';

import { session } from '../../../services/session';

import DateRangesDropdown from '../../base/dropdowns/dateranges-dropdown';
import Graph from './graph';
import { Loader, NoResult } from '../../misc/loader-utils';
import NetworksDropdown from '../../base/dropdowns/networks-dropdown';

import './earnings-graph.scss';

const primaryGraphTypes = [
  'publisher_total_earnings',
  'total_attributed_revenue',
  'clicks',
  'publisher_epc',
];
const secondaryGraphTypes = ['total_attributed_revenue', 'clicks'];

const graphLabelMap = {
  clicks: 'Clicks',
  publisher_epc: 'EPC',
  publisher_total_earnings: 'Earnings',
  total_attributed_revenue: 'Revenue',
};

const EarningsGraph = props => {
  const graphTypes = session.isOrgAdmin ? primaryGraphTypes : secondaryGraphTypes;

  const defaultRange = props.rangeDropdownItems.find(item => item.selected);
  const [selectedRange, setSelectedRange] = useState(defaultRange);
  const [graphType, setGraphType] = useState(graphTypes[0]);

  function updateRange(rangeDropdownItems) {
    const newRange = rangeDropdownItems.find(item => item.selected);
    setSelectedRange(newRange);
  }

  const graphTypesEl = graphTypes.map((type, i) => {
    const selected = graphType === type ? 'selected' : '';

    return (
      <div key={i} className={`graph-view ${type} ${selected}`} onClick={() => setGraphType(type)}>
        <span className={`color-block ${type}`}></span>
        <span className="text">{graphLabelMap[type]}</span>
      </div>
    );
  });

  const dateRanges = (
    <DateRangesDropdown
      gaEvent={{
        category: 'Publisher Dashboard',
        label: `${graphType} Date Range`,
      }}
      items={props.rangeDropdownItems}
      updateRange={updatedItems => updateRange(updatedItems)}
    />
  );

  const rangeType = selectedRange.name;
  const graph =
    !props.loading && !props.showNoResult ? (
      <Graph
        data={props.graphDataByRange[rangeType]}
        projections={props.projectionsByRange[rangeType]}
        graphType={graphType}
        rangeType={rangeType}
        graphLabelMap={graphLabelMap}
      />
    ) : null;

  return (
    <div className="earnings-graph">
      <div className="header">
        <div className="legend">{graphTypesEl}</div>
        <div className="options">{dateRanges}</div>
      </div>
      <Loader loading={props.loading} />
      <NoResult type="earnings-graph" noResult={!props.loading && props.showNoResult} />
      {graph}
    </div>
  );
};

export default EarningsGraph;
